<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
    <div class="col-12 mb-4">
      <v-card elevation="0">
         <div class="col-12 m-0 p-0">
            <v-btn @click="$router.go(-1)" small class="mt-2 light-btn"> <i class="mdi mdi-arrow-left-thin"></i> {{ $t('business_menu')}}</v-btn>
         </div>
          <div class="mt-0 pt-0 mb-0 pb-0">
                <v-alert type="info">
                    {{ $t('business_product_entry')}}
                </v-alert>
            </div>
        <v-tabs v-model="customers_tabs">
          <v-tab @click="initialize()">{{ $t('products.my_products') }}</v-tab>
          <v-tab>{{ $t('products.product_category') }}</v-tab>
          <v-tabs-items v-model="customers_tabs">
            <v-tab-item>
              <div v-if="categories && categories.length >0">
              <v-data-table
                  :headers="headersProducts"
                  :items="products"
                  :search="search"
                  sort-by="label"
                  class="elevation-1"
                  :loading="loadings.products" loading-text="Chargement en cours...">
                <template v-slot:top>
                  <v-row style="background: #f8f8f8;">
                    <v-col cols="12" sm="4">
                      <v-text-field solo
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row style="background: #f8f8f8;">
                    <v-toolbar
                        flat
                    >
                      <v-toolbar-title>{{ $t('products.my_products') }}</v-toolbar-title>
                      <v-spacer/>
                      <v-dialog
                          v-model="dialogProduct"
                          max-width="500px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              color="primary"
                              dark
                              @click="updatingProduct = false"
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                          >
                            {{ $t('products.new_product') }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-form ref="form" v-model="valid" enctype="multipart/form-data">
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                    <h4>{{ productDialogTitle }}</h4>
                                  </v-col>
                                  <div class="col-12">
                                    <v-btn class="btn btn-light btn-sm" text @click="dialogSheetUpload = true, dialogProduct = false, dialogCategory = false" >
                                    <v-icon>mdi-microsoft-excel</v-icon>  Ajouter via un fichier xlxs
                                    </v-btn>
                                  </div>
                                  <v-col cols="12" sm="12" md="12" class="mb-0 pb-0">
                                    <label> Assigner une catégorie</label>
                                    <v-autocomplete solo
                                        label="Catégorie du produit"
                                        v-model="product.category_id"
                                        :items="categories"
                                        :rules="requiredRules"
                                        item-text="_name"
                                        item-value="_id"
                                    ></v-autocomplete>
                                   </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                    <label>Ajouter une image du produit</label>
                                  <v-file-input solo
                                      v-model="product._image"
                                      label="Ajouter une image (cliquez pour choisir)"
                                  ></v-file-input>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col
                                      cols="12"
                                      sm="9"
                                      md="9"
                                  >
                                  <label>Nom du Produit</label>
                                    <v-text-field solo
                                        v-model="product._name"
                                        label="Nom du produit"
                                        :rules="requiredRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      sm="3"
                                      md="3"
                                  >
                                  <label>Prix (F CFA))</label>
                                    <v-text-field solo
                                        v-model="product._price"
                                        :rules="requiredRules"
                                        label="Prix unitaire"
                                        type="number"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12"
                                      sm="12"
                                      md="12" class="mb-0 pb-0">
                                      <label>Décrire le produit</label>
                                    <v-textarea solo label="Description" rows="2" v-model="product._description"/>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </v-card-text>

                          <v-card-actions class="mt-0 pt-0">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="dark"
                                @click="dialogProduct = false"
                            >
                              Annuler
                            </v-btn>
                            <v-btn
                                v-if="!updatingProduct"
                                color="primary"
                                :loading="loadings.productSaving"
                                @click="save"
                            >
                              Enregistrer
                            </v-btn>
                            <v-btn
                                color="primary"
                                v-if="updatingProduct"
                                :loading="loadings.productSaving"
                                @click="save"
                            >
                              Mettre à jour
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </v-row>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div style="text-align:  right">
                    <v-menu
                        key="text"
                        rounded="b-xl">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                            class="black--text "
                            v-bind="attrs"
                            v-on="on">mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                            v-for="(action_item, index) in actions_items"
                            :key="index"
                            link
                            @click="editItemAction(item,index)">
                          <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>

                </template>
                <template v-slot:item._image="{ item }">
                  <v-col>
                  <v-img
                      :src="admin_url+'/'+item._image"
                      :lazy-src="admin_url+'/'+item._image"
                      max-width="50"
                      max-height="50"
                      aspect-ratio="1"
                      class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                      >
                        <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  </v-col>
                </template>

                <template v-slot:no-data>
                  <span>{{ $t('users.no_users_found') }}</span>
                </template>
              </v-data-table>
              <!-- product pagination -->
               <div class="text-right col-12" style="background : #f8f8f8">
                <v-pagination
                elevation="0"
                v-model="page"
                :length="total_pages"
                :total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="getProductFilter"
                ></v-pagination>
              <!-- product pagination -->
              </div>
        </div>
        <div v-else>
                <div class="alert alert-danger mt-5 mb-5">
                  Vous devez ajouté des catégories avant de continuer. Cliquer sur le bouton <strong>&nbsp; catégories produit  &nbsp;</strong> ci-dessus pour créer de nouvelle catégorie.
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <ProduitsCategories/>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </div>

 <!-- Importe sheet data -->
    <v-dialog v-model="dialogSheetUpload" max-width="530px" >
                        
                            <v-card>
                              <v-card-title>
                                <h4 class=" pt-4"> Téléverser un fichier sheet</h4>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="sheetForm">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" sm="12">
                                        <label> Quel type de donnée voulez vous importé ? :</label>
                                          <v-radio-group v-model="type_import" row class="pt-0 mt-0">
                                            <v-radio label=" Liste de Produits"  value="produit" class="mt-1">
                                            </v-radio>
                                            <v-radio label="Liste de Catégories produit" class="mt-1" value="categorie">
                                            </v-radio>
                                          </v-radio-group>
                                      </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Téléverser un fichier xlxs pour ajouter des clients ou des catégories clients en masse.</label>
                                      <v-file-input accept=".xlsx, .xls" :rules="sheetrules" ref="sheet" solo show-size v-model="sheet"></v-file-input>
                                        <h6> Téléchager un modèle xlsx client<a href="/excels/intram-produit-model.xlsx" target="_blank" download="intram-client-model.xlsx"> ici </a></h6>
                                        <h6> Téléchager un modèle xlsx categorie client<a href="/excels/intram-categorie-produit-model.xlsx" target="_blank" download="intram-categorie-client-model.xlsx"> ici </a></h6>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-actions class="pt-0 mt-0">
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="12" class="text-right mt-0 pt-0">
                                <v-btn
                                    color="dark"
                                    @click="dialogSheetUpload= false, sheet=[]"
                                >
                                  Annuler
                                </v-btn>
                                <v-btn class="ml-2"
                                :disabled="sheet.length <= 0"
                                    color="primary"
                                    type="submit"
                                    :loading="sheetSaving"
                                    @click="saveMassCustomer"
                                >
                                  Enregistrer
                                </v-btn>
                                </v-col>
                              </v-card-actions>
                            </v-card>
    </v-dialog>
   <!-- *********************************** -->


  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import {mapState} from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import {client} from "../../store/services/client";
import ProduitsCategories from "./ProduitsCategory";
import {env} from "../../../env";

export default {
  components: {ProduitsCategories, GoToParams},
  label: "Customers",
  data() {
    return {
      type_import:'client',
      sheet:[],
      sheetrules: [
        value => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!',
      ],
      dialogSheetUpload:false,
      sheetSaving:false,
      requiredRules: [
        v => !!v || 'Ce champ est recquis',
      ],
      admin_url:env.admin,
      dialogDeleteCategory: false,
      products_tabs: [],
      loadings: {
        products: false,
        categories: false,
        productSaving: false,
      },
      total_pages: 0,
      page: 1,
      country_key: '',
      dialogProduct: false,
      lazy: false,
      valid: false,
      icon: '',
      errors: {},
      search: '',
      dialogCategory: false,
      id: undefined,
      customers_tabs: '',
      products: [],
      updatingProduct: false,
      headersCategories: [
        {text: '', value: '_icon'},
        {text: 'Nom catégorie', value: '_name'},
        {text: 'Description', value: '_description'},
        {text: '', value: 'actions', sortable: false},
      ],
      headersProducts: [
        {text: '-', value: '_image'},
        {text: 'Nom Produit', value: '_name'},
        {text: 'Prix', value: '_price'},
        {text: 'Description', value: '_description'},
        {text: '', value: 'actions', sortable: false},
      ],
      editedIndex: -1,
      editedItem: {},
      user_role: '',
      actions_items: [
        {title: "Modifier", avatar: 'mdi-pencil'},
        {title: "Supprimer", avatar: 'mdi-delete'},
      ],
      categories: undefined,
      product: {
        _name: "",
        _prix: "",
        _description: "",
        _image: null,
        _price: 0,
        category_id: null,
        _id: null,
      }

    }
  },
  computed: {
    ...mapState('users/', ['clients']),
    productDialogTitle: function () {
      return this.updatingProduct ? 'Mis a jour de produit' : 'Ajouter nouveau produit'
    },
    drop_down_user_countries: function () {
      let arr = [{text: "Tous les utilisateurs", value: -1}];

      if (this.countries) {
        this.countries.forEach((country) => {
          arr.push({text: country._name, value: country._id})
        });
      }

      return arr;
    },
    ...mapState('countries/', ['countries']),
    formCategoryTitle() {
      return ""
    }

  },
  mounted() {
    this.initialize();
    this.$store.dispatch('countries/getCountries').then(response => {
    });

  },
  methods: {
     async saveMassCustomer() {
        this.sheetSaving = true;
        let data = new FormData();
        data.append('sheet',this.sheet);
        data.append('type',this.type_import);
        const response = await client({
          method: 'post',
          url: '/marchand/product/post/sheet',
          data: data
        })
            .then(resp => {
              this.sheet=[];
              return resp.data;
            })
            .catch(error => {
              return {
                error: "true"
              }
            })
        this.dialogSheetUpload = false;
        this.sheetSaving = false;
        this.getMarchanProducts()
        this.getProductCategories();
        this.toast(response.type, response.message)
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loadings.productSaving = true;
        let formData = new FormData();
        formData.append('_name', this.product._name);
        formData.append('_prix', this.product._prix);
        formData.append('_description', this.product._description);
       
       if(this.updatingProduct){
          formData.append('_id', this.product._id);
          this.product._image ? formData.append('_image', this.product._image) : ''
         }else{
            formData.append('_image', this.product._image)
         }
        formData.append('_price', this.product._price);
        formData.append('category_id', this.product.category_id);
        const response = await client({
          method: 'post',
          url: '/marchand/product/post',
          data: formData
        }).then(resp => {
              this.getMarchanProducts()
              this.$refs.form.reset();
              return resp.data;
            })
            .catch(error => {
              console.log(error)
              return {
                error: "true"
              }
            })
        this.loadings.productSaving = false;
        this.dialogProduct = false;
        this.toast(response.type, response.message)
      }
    },
    async getProductCategories() {
      const response = await client({
        method: 'get',
        url: '/marchand/category_product/get'
      })
          .then(resp => resp.data)
          .catch(error => {
            console.log(error)
            return {
              error: "true"
            }
          })
      if (!response.error) {
        this.categories = response.categorieproducts
      }
    },
    initialize() {
      this.getProductCategories()
      if (this.$store.getters.marchand)
        this.getMarchanProducts()

    },
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleUpdateProduct(item)
          break;
        case 1:
          this.toggleDeleteProduct(item);
          break;
      }
    },
    toggleUpdateProduct(item){
      this.updatingProduct = true;
      this.dialogProduct = true
      this.product = item
      this.product._image = null
      this.product._image_preview = item._image
    },
    toggleDeleteProduct(){

    },
    async getProductFilter(page){
                 page=page-1;
                 const response = await client({
                    method: 'post',
                    url: '/marchand/product/get/paginate',
                    data: {page:page}
                  })
                      .then(resp => resp.data)
                      .catch(error => {
                        console.log(error)
                        this.loadings.products = false;
                        return {
                          error: "true"
                        }
                      })
                  if (!response.error) {
                    this.loadings.products = false;
                    this.page=response.page+1;
                    this.products = response.products
                    this.total_pages = response.total_pages
                  }
            },
    async getMarchanProducts() {
      let page=this.page-1;
      this.loadings.products = true;
      const response = await client({
        method: 'post',
        url: '/marchand/product/get/paginate',
        data: {page:page}
      })
          .then(resp => resp.data)
          .catch(error => {
            console.log(error)
            this.loadings.products = false;
            return {
              error: "true"
            }
          })
      if (!response.error) {
        this.loadings.products = false;
        this.page=response.page+1;
        this.products = response.products
        this.total_pages = response.total_pages
      }
    },
    goToUserDetails(id) {
      let url = '/users/' + id;
      this.$router.push(url);
    },
    checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },

    filterUsers(criteria) {
      let VueBox = this;
      this.$store.dispatch('users/filterClient', {
        country_id: VueBox.country_key,
        isMarchand: VueBox.$store.getters.marchand !== null
      })
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize()
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

}
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.light-btn{
  background: #ffffff !important;
  color: #222121 !important;
}
</style>
